var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuyers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "17px",
    viewBox: "0 0 20 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#95A6B0",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5789 3.36842H2.57895C1.70692 3.36842 1 4.07534 1 4.94737V14.4211C1 15.2931 1.70692 16 2.57895 16H17.5789C18.451 16 19.1579 15.2931 19.1579 14.4211V4.94737C19.1579 4.07534 18.451 3.36842 17.5789 3.36842Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3158 3.36842V2.18421C7.3158 1.87014 7.44056 1.56893 7.66264 1.34685C7.88473 1.12476 8.18593 1 8.50001 1H11.6579C11.972 1 12.2732 1.12476 12.4953 1.34685C12.7173 1.56893 12.8421 1.87014 12.8421 2.18421V3.36842"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyers);
export default __webpack_public_path__ + "static/media/Buyers.484aaaba07177946ebc7a149d1c3e096.svg";
export { ForwardRef as ReactComponent };